import { ObjectNames } from './../../../../modules/shared/constants/object.names';
import { SharedChannelService } from './../../../../modules/shared/services/channel.service';
import { PermissionService } from './../../../../service/permission.service';
import { ChannelN } from './../../../../modules/shared/models/channel.model';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { RouteManagementService } from '../../route-management.service';
import { FormErrorHandler } from 'src/app/modules/shared/helpers/form-error-handler.helper';
import { AppMainService } from 'src/app/app-main.service';
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { AppMainComponent } from 'src/app/app.main.component';
import { IRouteAddEdit, IRouteAddress, IRouteObject, IRouteTerritory } from '../../models/route-add-edit.model';
import { ColumnSettingsN, Fields } from 'src/app/cases-v2/models/column-settings.model';
import { ParseHelper } from 'src/app/modules/shared/parse.helper';
import { SharedColumnSettingsService } from 'src/app/modules/shared/services/column-settings.service';
import { FilterInColumn } from 'src/app/accounts-v2/models/account-request.model';
import { AccountHelper } from 'src/app/accounts-v2/services/accounts.helper';
import { syncColumnSettings } from 'src/app/modules/shared/helpers/sync-column-setting.helper';
import { getSectionWiseFlatCols } from 'src/app/modules/shared/helpers/section-wise-cols.helper';
import { AccountModuleId, LeadModuleId } from 'src/app/modules/shared/constants/modules.constant';
import { Status } from 'src/app/models/statusEnums';
declare var google: any;
@Component({
    selector: 'app-add-edit-route',
    templateUrl: './add-edit-route.component.html',
    styleUrls: ['./add-edit-route.component.scss']
})
export class AddEditRouteComponent implements OnInit, OnDestroy, OnChanges {

    private ngUnsubscribe$ = new Subject<void>();

    //Input decorator
    @Input() crudType: 'add' | 'update' | 'clone' | 'view' = 'add';
    @Input() populateAddPopupDirectly: boolean = false;
    @Input() displayAddEditRoute: boolean = false;
    @Input() selectedRouteEditId: number = 0;
    @Input() routeModuleId: number = AccountModuleId;
    @Input() routeChannelId: number;
    @Input() selectedTerritoryId: number;
    @Input() selectedTerritory: any = null;
    @Input() filteredTerritoryIds: any[] = [];
    @Input() routeViewOnly: boolean = false;

    //output decorator
    @Output() closeModal = new EventEmitter();
    @Output() reloadList = new EventEmitter();

    //Route form vairables
    routeForm: FormGroup;
    viewModeNew = [
        { label: 'List View', value: 'classic' },
        { label: 'Map View', value: 'map' }
    ];
    selectedViewModeNew: string = 'classic';
    startAddressInput: string = '';
    endAddressInput: string = '';
    detailsFormErrors: any = {};
    formErrorHandler: FormErrorHandler = new FormErrorHandler();

    //models
    dialogHeader: 'Add New Route' | 'Edit Route' | 'View Route' = 'Add New Route';
    mergeAccountSequenceNumber: boolean = true;

    startAddress: IRouteAddress;
    endAddress: IRouteAddress;
    userList: any[] = [];
    routeModules: any[] = [
        { id: AccountModuleId, name: 'Account' },
        { id: LeadModuleId, name: 'Lead' },
    ];

    //selected stores
    accountColLists: any[] = [];
    businessList = [];
    routesLists = [];
    editRouteStoreList = [];

    routeColumnSetttings: Partial<ColumnSettingsN> = {};
    savedAccountListCols: Fields[] = [];

    //pagination
    first = 0;
    tableShowMore: number[] = [15, 30, 50, 100];
    pageSize: number = 15;
    pageNumber: number = 1;
    totalRecords: number = 0;
    lsttotalRecords: number;
    loading: boolean;
    selectedBusiness: any;

    selectedStore: boolean = false;
    displayRouteTB: boolean = false;
    globalFilterInputBS: string = '';
    gridState: any = {};

    displayColumnSettings: boolean = false;
    channelsN: ChannelN[] = [];
    selectedChannelN: ChannelN = null;
    territoryNamesList: any[] = [];
    oldSelectedTerritory: any = null;

    newFillterListCols: Fields[] = [];
    filterInColumns: FilterInColumn[] = [];
    appliedFilterColName: string[] = [];
    selectedFilterModule: any;

    //route edit
    routeDetails: any;

    constructor(
        public app: AppMainComponent,
        private fb: FormBuilder,
        private confirmationService: ConfirmationService,
        private routeManagementService: RouteManagementService,
        private appMainService: AppMainService,
        private messageService: MessageService,
        private sharedColumnSettingsService: SharedColumnSettingsService,
        private permissionService: PermissionService,
        private sharedChannelService: SharedChannelService,
        private accountHelper: AccountHelper
    ) { }

    ngOnInit(): void {
        this.userList = this.app.usersList||[];
        this.userList = this.userList.filter(user=> user?.statusId==Status.Active)
        this.openRouteAddEdit();
        this.initAddEditRouteForm();
        this.getAccountChannel();
        !this.selectedRouteEditId && this.getAllTerritoryList(this.routeChannelId);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.selectedTerritory && changes?.selectedTerritory?.currentValue) {
            this.selectedTerritory = changes?.selectedTerritory?.currentValue;
        }

        if (changes?.filteredTerritoryIds && changes?.filteredTerritoryIds?.currentValue) {
            this.filteredTerritoryIds = changes?.filteredTerritoryIds?.currentValue;
        }

        if (changes?.routeChannelId && changes?.routeChannelId?.currentValue) {
            this.routeChannelId = changes?.routeChannelId?.currentValue;
        }

        if (changes?.displayAddEditRoute && changes?.displayAddEditRoute?.currentValue) {
            this.displayAddEditRoute = changes?.displayAddEditRoute?.currentValue;
        }

        if (changes?.crudType && changes?.crudType?.currentValue) {
            this.crudType = changes?.crudType?.currentValue;
        }

        if (changes?.routeViewOnly && changes?.routeViewOnly?.currentValue) {
            this.routeViewOnly = changes?.routeViewOnly?.currentValue;
        }

        if (changes?.selectedRouteEditId && changes?.selectedRouteEditId?.currentValue) {
            this.selectedRouteEditId = changes?.selectedRouteEditId?.currentValue;
            this.loadRouteDetails(this.selectedRouteEditId);
        }
    }

    openRouteAddEdit() {
        switch (this.crudType) {
            case 'add':
                this.dialogHeader = 'Add New Route';
                break;
            case 'update':
                this.dialogHeader = 'Edit Route'
                break;
            case 'view':
                this.dialogHeader = 'View Route'
                break;
            default:
                break;
        }
    }

    initAddEditRouteForm() {
        this.detailsFormErrors = {};
        this.clearFields();
        this.routeForm = this.fb.group({
            routeName: ['', [Validators.required]],
            objectTypeId: [this.routeModuleId],
            userId: [this.app?.userId || null, [Validators.required]],
            isEndLocationSame: [false]
        });

        this.formErrorHandler.handleErrors(this.routeForm, this.detailsFormErrors, {
            routeName: {
                required: "Route name is requried"
            },
            userId: {
                required: "Please select any user"
            }
        });
    }

    closeRouteDialog() {
        this.displayAddEditRoute = false;
        this.enableFormControls();
        this.closeModal.emit();
    }

    enableFormControls() {
        this.routeForm.enable();
    }

    clearFields() {
        this.selectedViewModeNew = 'classic';
    }

    // when select start addresss
    addressChange(address: any) {
        this.startAddressInput = address.formatted_address;
        this.startAddress = {
            streetAddress1: address.formatted_address,
            latitude: this.convertToNum(address.geometry.location.lat()),
            longitude: this.convertToNum(address.geometry.location.lng())
        }
    }

    // when select end addresss
    endLocationChange(address: any) {
        this.endAddress = {
            streetAddress1: address.formatted_address,
            latitude: this.convertToNum(address.geometry.location.lat()),
            longitude: this.convertToNum(address.geometry.location.lng())
        }
    }

    // When click on checkbox same as start location
    onSameasStartLocation(event) {
        if (event.checked == true) {
            this.endAddressInput = this.startAddressInput;
        }
        else {
            this.endAddressInput = ""
            this.endAddress = {
                streetAddress1: "",
                latitude: null,
                longitude: null
            };
        }
    }

    convertToNum(params: any) {
        if (params == null || params == undefined || Number.isNaN(params))
            return 0;
        else
            return params;
    }

    changeViewMode(event) {
        if (this.selectedViewModeNew == 'map') {
            setTimeout(() => {
                this.calculateDistance('gmap');
            }, 100)
        }
    }

    //#region ***Add/Edit Route***
    scrollToError(): void {
        const firstElementWithError = document.querySelector('.ng-invalid[formControlName]');
        this.scrollTo(firstElementWithError);

        if (!firstElementWithError) {
            const secondElementWithError = document.querySelector('.p-invalid');
            this.scrollTo(secondElementWithError);
        }
    }

    // Scroll to error element
    scrollTo(el: Element): void {
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    async saveRoute() {
        if (this.routeForm.invalid) {
            this.routeForm.markAllAsTouched();
            this.routeForm.markAsDirty();
            this.formErrorHandler.showErrorOnSubmit();
            this.scrollToError();
            return; //Return if form invalid
        }
        this.appMainService.isShowSpinner('RouteSaveEdit');
        await this.calculateDistance();
        const totalDistance = localStorage.getItem("totalDistance") || '0';

        const savedColumnSettings = {
            listViewSections: this.routeColumnSetttings?.listViewSections || null
        }
        let routeBusiness = this.editRouteStoreList;
        let routeObject: IRouteObject[] = [];
        for (let route of routeBusiness) {
            let eachRoute = {
                id: route.id == undefined ? 0 : route.id,
                routeId: this.routeDetails?.id||0,
                channelId: route?.channelId,
                territoryId: route?.territoryId,
                objectRefId: route.objectRefId,
                objectRefRecordId: route.objectRefRecordId,
                totalDistance: route.totalDistance,
                totalTime: route.totalTime,
                statusId: 1,
                displayOrder: 0,
                latitude: this.convertToNum(route.latitude),
                longitude: this.convertToNum(route.longitude)
            }
            routeObject.push(eachRoute);
        }

        let formValue = this.routeForm.getRawValue();

        let routeData: IRouteAddEdit = {
            id: this.routeDetails?.id ? this.routeDetails.id : 0,
            columnSetting: this.getColumnSettingObj(savedColumnSettings),
            name: formValue.routeName,
            address: this.startAddress,
            addressId: 0,
            endLocationId: 0,
            endAddress: this.endAddress,
            userId: formValue.userId,
            objectTypeId: formValue.objectTypeId,
            totalDistance: totalDistance,
            totalTime: null,
            isValid: true,
            routeObject: routeObject,
            isEndlocationSame: formValue.isEndLocationSame
        }

        if (this.selectedRouteEditId > 0) {
            // this.appMainService.isShowSpinner('editRoute');
            this.routeManagementService.updateNewRoute(routeData).subscribe({
                next: (response) => {
                    this.appMainService.isHideSpinner('RouteSaveEdit');
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Route Updated successfully...' });
                    this.displayAddEditRoute = false;
                    this.reloadList.emit(response);
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('RouteSaveEdit');
                    this.messageService.add({ severity: 'error', summary: 'Failed To Update', detail: error.error.Message ? error.error.Message : 'Error occurred while saving data...' });
                }
            })

        } else {
            // this.appMainService.isShowSpinner('addRoute');
            this.routeManagementService.addNewRoute(routeData).subscribe({
                next: (response) => {
                    this.appMainService.isHideSpinner('RouteSaveEdit');
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Route added successfully...' });
                    this.displayAddEditRoute = false;
                    this.reloadList.emit(response);
                    if (this.filteredTerritoryIds?.length > 0) {
                        this.closeModal.emit();
                    }
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('RouteSaveEdit');
                    this.messageService.add({ severity: 'error', summary: 'Failed To Add', detail: error.error.Message ? error.error.Message : 'Error occurred while saving data...' });
                }
            })
        }

    }
    //#endregion ***Add/Edit***

    // #region ***Edit Route Methods***

    loadRouteDetails(routeId: number) {
        this.appMainService.isShowSpinner('loadRouteDetails');
        this.routeManagementService.getNewRouteByID(routeId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response) => {
                this.appMainService.isHideSpinner('loadRouteDetails');
                this.routeDetails = response;
                this.routeDetails = this.routeDetails ? { ...this.routeDetails, id: routeId } : null;
                this.setRouteEditDetails();
            },
            error: (error) => {
                this.appMainService.isHideSpinner('loadRouteDetails');
                this.messageService.add({ severity: 'error', summary: 'Failed to Get Details', detail: 'Error occurred while get route detials, please try again.' });
            },
            complete: () => {

            }
        })
    }

    setRouteEditDetails() {
        const startAddress: IRouteAddress = this.routeDetails?.address
        const endAddress: IRouteAddress = this.routeDetails?.endAddress
        this.startAddress = {
            streetAddress1: startAddress?.streetAddress1,
            latitude: this.convertToNum(startAddress?.latitude),
            longitude: this.convertToNum(startAddress?.longitude),
        }
        this.endAddress = {
            streetAddress1: endAddress?.streetAddress1,
            latitude: this.convertToNum(endAddress?.latitude),
            longitude: this.convertToNum(endAddress?.longitude),
        }
        this.startAddressInput = this.routeDetails?.address == null ? '' : this.routeDetails?.address.streetAddress1;
        this.endAddressInput = this.routeDetails?.endAddress == null ? '' : this.routeDetails?.endAddress.streetAddress1;
        this.selectedTerritoryId = this.routeDetails?.routeTerritory?.territoryId||this.selectedTerritoryId;

        this.routeForm.patchValue({
            routeName: this.routeDetails.name,
            objectTypeId: this.routeDetails.objectTypeId,
            userId: this.routeDetails.userId,
            isEndLocationSame: this.routeDetails.isEndlocationSame
        });


        this.bindRouteStoreEdit(this.routeDetails?.id);
        this.getAllTerritoryList(this.selectedChannelN?.id||this.routeChannelId);

        if (this.routeViewOnly) {
            this.disableFormControl();
        }
    }

    bindRouteStoreEdit(routeId: number) {
        this.appMainService.isShowSpinner('editRouteStore');
        this.routeManagementService.BindNewRouteStoreLocationListing(routeId, 0, false, 0, 0, "", "", "", true)
            .subscribe({
                next: (data) => {
                    // Handle the data
                    this.appMainService.isHideSpinner('editRouteStore');
                    let { routes, headers } = data;
                    this.routeColumnSetttings = routes?.columnSetting && routes?.columnSetting ? JSON.parse(routes?.columnSetting) : null;
                    this.routesLists = routes?.lead || routes?.account || [];
                    this.editRouteStoreList = JSON.parse(JSON.stringify(this.routesLists));
                    this.chooseAccountCol(this.selectedChannelN?.id);
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('editRouteStore');
                }
            });
    }

    disableFormControl() {
        this.routeForm.disable();
    }
    // #endregion *** Edit Route Methods***

    //#region store selection
    showRouteTB() {
        this.selectedFilterModule = { name: this.selectedTerritory?.territorytype, objectId: this.routeForm.getRawValue().objectTypeId, channelId: this.selectedChannelN?.id || this.routeChannelId };
        this.setGridListColsForAccount(this.routeColumnSetttings);
        this.first = 0;
        this.displayRouteTB = true;
        this.globalFilterInputBS = "";
        this.filteredTerritoryIds = [];
        this.selectedBusiness = JSON.parse(JSON.stringify(this.routesLists));
    }

    resetRouteTB() {
        this.displayRouteTB = false;
        this.first = 0;
        this.editRouteStoreList = JSON.parse(JSON.stringify(this.routesLists));
        this.selectedBusiness = JSON.parse(JSON.stringify(this.routesLists));
    }

    saveRouteTB() {
        this.first = 0;
        this.editRouteStoreList = this.editRouteStoreList.filter(l => this.formatAddress(l));
        if (this.editRouteStoreList?.length > 25) {
            this.messageService.add({ severity: 'error', summary: 'You can select maximum 25 accounts!' });
            return;
        }

        this.accountColLists = this.savedAccountListCols;
        this.routesLists = JSON.parse(JSON.stringify(this.editRouteStoreList));
        this.displayRouteTB = false;
        this.selectedStore = false;
        this.gridState['filters'] = [];
    }

    resetData() {
        this.confirmationService.confirm({
            message: "Are you sure you want to clear the added stores?",
            header: "Clear Confirmation",
            icon: "pi pi-info-circle",
            accept: () => {
                this.routesLists = [];
                this.editRouteStoreList = [];
            },
            reject: () => {}
        });
    }

    removeStore(rowData: any) {
        const index = this.editRouteStoreList.findIndex(account => account.id == rowData.id);
        if (index >= 0) {
            this.editRouteStoreList.splice(index, 1);
            this.routesLists = JSON.parse(JSON.stringify(this.editRouteStoreList));
        }
    }

    onDialogHide() {
        this.savedAccountListCols = this.savedAccountListCols.map(col => {
            col.value = '';
            return col;
        });
        this.filterInColumns = [];
        this.selectedFilterModule = {};
    }

    onChangeModule(){
        this.getAccountChannel();
        this.routeForm.getRawValue().userId && this.getAllTerritoryList(this.selectedChannelN?.id||this.routeChannelId);
    }

    getAccountChannel() {
        const globalChannelId = this.permissionService.getGlobalChannelId();
        if (typeof globalChannelId === 'number') {
            this.selectedChannelN = { id: globalChannelId } as any;
        }
        this.sharedChannelService.getChannels(this.routeForm.getRawValue().objectTypeId).subscribe(
            {
                next: (response) => {
                    const channels = response || [];
                    const objectName = this.routeForm.getRawValue().objectTypeId==LeadModuleId ? ObjectNames.LEAD : ObjectNames.ACCOUNT;
                    this.channelsN = this.permissionService.filterChannelsByPermissions(channels, objectName);
                    this.selectedChannelN = this.channelsN.find(x => x?.id === (this.routeChannelId || this.selectedChannelN?.id));
                    this.chooseAccountCol(this.selectedChannelN.id,this.populateAddPopupDirectly);
                },
                error: (error) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.message ? error?.error?.message : 'Channels are not loaded, please try again...'
                    });
                },
                complete: () => { },
            });
    }

    onChangeChannel($event) {
        this.chooseAccountCol(this.selectedChannelN?.id,false,true);
    }

    showSetting() {
        this.displayColumnSettings = true;
    }

    savedColumnSettings(data: { updatedColumnSettings: any, updateColumnSettingsData: any }) {
        this.displayColumnSettings = false;
        this.routeColumnSetttings = data?.updatedColumnSettings || {};
        this.setGridListColsForAccount(this.routeColumnSetttings);
    }

    getColumnSettingObj(newSettings) {
        return JSON.stringify(newSettings)
    }

    cancelColumnSettings() {
        this.displayColumnSettings = false;
    }

    chooseAccountCol(selectedChannelId: number, populateSelectedStore: boolean = false, loadTerritory: boolean = false) {
        this.app.appMainService.isShowSpinner('loaAccountColumnSettings');
        this.sharedColumnSettingsService.getColumnSettings(this.routeForm.getRawValue().objectTypeId, selectedChannelId).pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(
                {
                    next: (response) => {
                        this.app.appMainService.isHideSpinner('loaAccountColumnSettings')
                        let defaultColumnSettings: Partial<ColumnSettingsN> = {};
                        defaultColumnSettings = ParseHelper.DeepCopy(response);
                        if (this.routeColumnSetttings != null && this.routeColumnSetttings?.listViewSections?.length > 0) {
                            syncColumnSettings(this.routeColumnSetttings, defaultColumnSettings);
                            this.routeColumnSetttings = defaultColumnSettings;
                        } else {
                            this.routeColumnSetttings = defaultColumnSettings;
                        }

                        this.savedAccountListCols = defaultColumnSettings?.listViewSections?.length ? getSectionWiseFlatCols(defaultColumnSettings.listViewSections) : [];
                        this.newFillterListCols = this.accountHelper.getSectionWiseFlatCols(defaultColumnSettings?.listViewSections);
                        this.accountColLists = getSectionWiseFlatCols(defaultColumnSettings.listViewSections);

                        if (populateSelectedStore) {
                            if (this.filteredTerritoryIds?.length > 25) {
                                this.showRouteTB();
                            } else {
                                this.displayRouteTB = false;
                                this.bindStoreListFromTerritory(this.filteredTerritoryIds);
                            }
                        }else if(loadTerritory){
                            this.getAllTerritoryList(this.selectedChannelN?.id, true);
                        }
                    },
                    error: (error) => {
                        this.app.appMainService.isHideSpinner('loaAccountColumnSettings')
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: error?.error?.message ? error?.error?.Message : 'Column Settings are not loaded, please try again...'
                        });

                    },
                    complete: () => { },
                });
    }

    setGridListColsForAccount(columnSettings: Partial<ColumnSettingsN>) {
        this.savedAccountListCols = columnSettings?.listViewSections?.length ? getSectionWiseFlatCols(columnSettings.listViewSections) : [];
        this.newFillterListCols = columnSettings?.listViewSections?.length ? getSectionWiseFlatCols(columnSettings.listViewSections) : [];

        if (this.filteredTerritoryIds?.length <= 0) {
            this.first = 0;
            this.getAllSelectedObjectData(1, 15, true);
        } else {
            this.bindStoreListFromTerritory(this.filteredTerritoryIds);
        }
    }

    getAllTerritoryList(selectedChannelId: number, loadTerritoryObject: boolean = false) {
        this.selectedTerritory = null;
        this.businessList = [];

        this.appMainService.isShowSpinner('getAllTerritories');
        this.routeManagementService.getAllTerritoryiesByUser(this.routeForm.getRawValue().objectTypeId, selectedChannelId, true, this.routeForm.getRawValue().userId).subscribe({
            next: (response) => {
                const territoryTableData = this.addTerritoryLabel(response || []);
                this.territoryNamesList = JSON.parse(JSON.stringify(territoryTableData)) || [];
                this.territoryNamesList = this.territoryNamesList.filter(territory=> territory?.children?.length>0);
                const flattedTerritories = this.getFlatArrayFormChilren(this.territoryNamesList);
                this.selectedTerritory = flattedTerritories.find(obj => obj.id == this.selectedTerritoryId) || null;
                this.selectedTerritory = !this.selectedTerritory ? flattedTerritories.find(t => t.territoryType) : this.selectedTerritory;
                this.oldSelectedTerritory = this.selectedTerritory;

                if (loadTerritoryObject && this.selectedTerritory) {
                    this.first = 0;
                    this.getAllSelectedObjectData(1, 15, false);
                }

                this.appMainService.isHideSpinner('getAllTerritories');
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getAllTerritories');
            }
        })
    }

    changeTerritory(event) {
        if (!event.node.objectId) {
            setTimeout(() => {
                const previousSelectedTerritory = this.oldSelectedTerritory ? this.oldSelectedTerritory : null;
                this.selectedTerritory = previousSelectedTerritory;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Root Territory Not Selectable!' });
            }, 200)
            return;
        }
        this.selectedTerritory = event.node;
        this.oldSelectedTerritory = this.selectedTerritory;
        this.first = 0;
        this.getAllSelectedObjectData(1, 15, false);
    }

    onGlobalRouteStoreSearch() {
        this.first = 0;
        this.getAllSelectedObjectData(1, 15);
    }

    applyFilters(event: { selectedFilter: FilterInColumn[] }) {
        this.filterInColumns = event?.selectedFilter || null;
        this.first = 0;
        this.appliedFilterColName = (event?.selectedFilter ?? []).map((sf => sf.name));
        this.pageSize = 15;
        this.pageNumber = 1;
        this.getAllSelectedObjectData(this.pageNumber, this.pageSize);
    }

    paginationGetRouteStoreLocationListing(event: LazyLoadEvent) {
        if (event) {
            this.pageSize = event.rows;
            this.pageNumber = (event.first / event.rows) + 1;

            if (event.sortField) {
                const temp = {
                    field: event.sortField,
                    order: event.sortOrder
                };

                this.gridState['sort'] = temp;
            }
        }
        else {
            this.pageSize = 15;
            this.pageNumber = 1;
        }
        if (this.selectedTerritory != undefined) {
            this.getAllSelectedObjectData(this.pageNumber, this.pageSize, false);
        }
    }

    getAllSelectedObjectData(currentPageNumber: number = 1, currentPageSize: number = 15, fromUpdateSettings?: boolean): void {

        if ((this.savedAccountListCols?.length || 0) == 0) return;

        let pageNumber = currentPageNumber ? currentPageNumber : 1;
        this.pageNumber = pageNumber;
        this.pageSize = currentPageSize;
        const options: any = {};
        options.isActive = true;
        options.moduleSearchValue = this.globalFilterInputBS.trim() || '';

        const selectableColumns: any[] = [];

        if (this.savedAccountListCols?.length > 0) {
            this.savedAccountListCols.forEach((obj) => {
                if (obj.enabled) {
                    selectableColumns.push(
                        {
                            columnName: obj.columnName,
                            isCustom: obj.isCustom
                        }
                    )
                }
            });
        }
        const selectedStoreIds = this.selectedBusiness?.length ? this.selectedBusiness.map(item => item.objectRefRecordId) : null;
        const requestModel: any = {
            Ids: this.selectedStore ? selectedStoreIds : this.filteredTerritoryIds || null,
            channelId: this.selectedChannelN?.id,
            stageId: null,
            isActive: true,
            globalSearchValue: this.globalFilterInputBS.trim() || '',
            selectableColumns: selectableColumns,
            filter: null,
            pageSize: currentPageSize,
            pageNumber: currentPageNumber,
            sortByColumn: options?.sort?.SortBy || null,
            isSortByDescending: !options?.sort?.IsAscending,
            filterInColumns: this.filterInColumns,
            excludeDefaultColumns: true,
            countryId: this.selectedTerritory?.countryId || null,
            territoryId: this.selectedTerritory?.id || null,
            routeId: 0,
            includeChildAccounts: true,
            isAssigned: this.selectedStore ? true : false || this.filteredTerritoryIds?.length > 0 ? true : false,
            //includeClosedLeads: true
        }

        if (this.filterInColumns && this.filterInColumns?.length > 0 && requestModel) {
            this.filterInColumns.forEach((obj) => {
                let notInSelectableColumn = requestModel?.selectableColumns.find((item) => {
                    return item?.columnName == obj?.name;
                });
                let customFieldNotinSelectableColumn = this.savedAccountListCols.find((item) => {
                    return item?.columnName == obj?.name;
                });
                if (!notInSelectableColumn && customFieldNotinSelectableColumn) {
                    requestModel?.selectableColumns.push(
                        {
                            columnName: customFieldNotinSelectableColumn?.columnName,
                            isCustom: customFieldNotinSelectableColumn?.isCustom || false
                        }
                    );
                }
            });
        }

        if (this.routeForm.getRawValue().objectTypeId == AccountModuleId) {
            this.appMainService.isShowSpinner('getAccountList');
            let accountListCalling = this.routeManagementService.routePagedListForAccount(requestModel);

            accountListCalling.pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe({
                    next: (response) => {
                        if (response) {
                            this.businessList = response?.list || [];
                            this.businessList.map(list => {
                                list['TerritoryName'] = this.selectedTerritory?.name;
                                list['territoryId'] = this.selectedTerritory?.id;
                                list['channelName'] = this.selectedChannelN?.name;
                                list['channelId'] = this.selectedChannelN?.id;
                            });
                            this.lsttotalRecords = response?.totalNumberOfRows;
                            this.appMainService.isHideSpinner('getAccountList');
                        }
                    },
                    error: (error) => {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error!',
                            detail: 'Error occurring when loading accounts. Please try after sometime.'
                        });
                        this.appMainService.isHideSpinner('getAccountList');
                    },
                    complete: () => {

                    }
                })
        } else {
            this.appMainService.isShowSpinner('getAllLeads');
            let leadListCalling = this.routeManagementService.routePagedListForLead(requestModel);

            leadListCalling.pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe({
                    next: (response) => {
                        if (response) {
                            this.businessList = response?.list || [];
                            this.businessList.map(list => {
                                list['TerritoryName'] = this.selectedTerritory?.name;
                                list['territoryId'] = this.selectedTerritory?.id;
                                list['channelName'] = this.selectedChannelN?.name;
                                list['channelId'] = this.selectedChannelN?.id;
                            });
                            this.lsttotalRecords = response?.totalNumberOfRows;

                            this.appMainService.isHideSpinner('getAllLeads');
                        }
                    },
                    error: (error) => {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error!',
                            detail: 'Error occurring when loading leads. Please try after sometime.'
                        });
                        this.appMainService.isHideSpinner('getAllLeads');
                    },
                    complete: () => {

                    }
                })
        }
    }

    bindStoreListFromTerritory(filteredTerritoryIds) {
        const selectableColumns: any[] = [];

        if (this.accountColLists.length > 0) {
            this.accountColLists.forEach((obj) => {
                if (obj.enabled) {
                    selectableColumns.push(
                        {
                            columnName: obj.columnName,
                            isCustom: obj.isCustom
                        }
                    )
                }
            });
        }
        const requestModel: any = {
            Ids: filteredTerritoryIds,
            channelId: this.routeChannelId,
            stageId: null,
            isActive: true,
            globalSearchValue: this.globalFilterInputBS.trim() || '',
            selectableColumns: selectableColumns,
            filter: null,
            pageSize: 0,
            pageNumber: 0,
            sortByColumn: null,
            isSortByDescending: false,
            filterInColumns: this.filterInColumns,
            excludeDefaultColumns: true,
            countryId: this.selectedTerritory?.countryId || null,
            territoryId: this.selectedTerritory?.id || null,
            routeId: 0,
            includeChildAccounts: true,
            isAssigned: true,
            //includeClosedLeads: true
        }

        if (this.filterInColumns && this.filterInColumns?.length > 0 && requestModel) {
            this.filterInColumns.forEach((obj) => {
                let notInSelectableColumn = requestModel?.selectableColumns.find((item) => {
                    return item?.columnName == obj?.name;
                });
                let customFieldNotinSelectableColumn = this.savedAccountListCols.find((item) => {
                    return item?.columnName == obj?.name;
                });
                if (!notInSelectableColumn && customFieldNotinSelectableColumn) {
                    requestModel?.selectableColumns.push(
                        {
                            columnName: customFieldNotinSelectableColumn?.columnName,
                            isCustom: customFieldNotinSelectableColumn?.isCustom || false
                        }
                    );
                }
            });
        }

        if (this.routeForm.getRawValue().objectTypeId == AccountModuleId) {
            this.appMainService.isShowSpinner('getAccountList');
            let accountListCalling = this.routeManagementService.routePagedListForAccount(requestModel);

            accountListCalling.pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe({
                    next: (response) => {
                        if (response) {
                            this.businessList = response?.list || [];
                            this.businessList.map(list => {
                                list['TerritoryName'] = this.selectedTerritory?.name;
                                list['territoryId'] = this.selectedTerritory?.id;
                                list['channelName'] = this.selectedChannelN?.name;
                                list['channelId'] = this.selectedChannelN?.id;
                            });
                            if (this.filteredTerritoryIds?.length < 25) {
                                this.routesLists = this.businessList || [];
                                this.editRouteStoreList = JSON.parse(JSON.stringify(this.routesLists));
                            }
                            this.lsttotalRecords = response?.totalNumberOfRows;
                            this.appMainService.isHideSpinner('getAccountList');
                        }
                    },
                    error: (error) => {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error!',
                            detail: 'Error occurring when loading accounts. Please try after sometime.'
                        });
                        this.appMainService.isHideSpinner('getAccountList');
                    },
                    complete: () => {

                    }
                })
        } else {
            this.appMainService.isShowSpinner('getAllLeads');
            let leadListCalling = this.routeManagementService.routePagedListForLead(requestModel);

            leadListCalling.pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe({
                    next: (response) => {
                        if (response) {
                            this.businessList = response?.list || [];
                            this.businessList.map(list => {
                                list['TerritoryName'] = this.selectedTerritory?.name;
                                list['territoryId'] = this.selectedTerritory?.id;
                                list['channelName'] = this.selectedChannelN?.name;
                                list['channelId'] = this.selectedChannelN?.id;
                            });

                            if (this.filteredTerritoryIds?.length < 25) {
                                this.routesLists = this.businessList || [];
                                this.editRouteStoreList = JSON.parse(JSON.stringify(this.routesLists));
                            }
                            this.lsttotalRecords = response?.totalNumberOfRows;
                            this.appMainService.isHideSpinner('getAllLeads');

                        }
                    },
                    error: (error) => {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error!',
                            detail: 'Error occurring when loading leads. Please try after sometime.'
                        });
                        this.appMainService.isHideSpinner('getAllLeads');
                    },
                    complete: () => {

                    }
                })
        }
    }

    onAssignedCheckboxChange() {
        this.first = 0;
        this.getAllSelectedObjectData(1, 15, true);
    }

    CheckAllRoute(event) {
        this.businessList.forEach(element => {
            if (event)
                this.selectStore(element);
            else
                this.unselectStore(element);
        });

        this.selectedBusiness = JSON.parse(JSON.stringify(this.editRouteStoreList));
    }

    onRowSelectRoute(e) {
        if (e.type != 'checkbox')
            this.selectStore(e.data);
    }

    onRowUnSelectRoute(em) {
        if (em.type != 'checkbox')
            this.unselectStore(em.data);
    }

    selectStore(l) {
        const exist = this.editRouteStoreList.find(e => e.objectRefRecordId == l.objectRefRecordId);
        const address = this.formatAddress(l);
        if (exist || !address) return;

        this.editRouteStoreList.push({ ...l, isSelected: true });

        if (this.selectedViewModeNew != 'map') {

        }
    }

    unselectStore(l) {
        this.editRouteStoreList = this.editRouteStoreList.filter(item => item.objectRefRecordId !== l.objectRefRecordId);

        if (this.selectedViewModeNew != 'map') {

        }
    }

    CheckRoute(event, rowdadata) {
        if (!event) {
            this.selectStore(rowdadata);
        }
        else {
            this.unselectStore(rowdadata);
        }
    }

    //#endregion

    // #region  ***method to modify data***
    addTerritoryLabel(originalData) {
        const convertedData = originalData.map((item) => {
            const { children, ...data } = item;
            const childrenData = this.addTerritoryLabel(children);
            return {
                ...data,
                label: data.name,
                children: childrenData,
            };
        });
        return convertedData;
    }

    getFlatArrayFormChilren(members: any[]) {
        let children = [];
        return members.map(m => {
            if (m.children && m.children?.length) {
                children = [...children, ...m.children];
            }
            return m;
        }).concat(children?.length ? this.getFlatArrayFormChilren(children) : children);
    }

    formatAddress(routeDetails: any) {
        let address: string = "";
        if (routeDetails?.streetAddress1) {
            address = address.concat(routeDetails?.streetAddress1);
        }

        if (routeDetails?.streetAddress2) {
            address = address + (address ? "," : "") + routeDetails?.streetAddress2;
        }

        if (routeDetails?.city) {
            address = address + (address ? "," : "") + routeDetails?.city;
        }

        if (routeDetails?.state) {
            address = address + (address ? "," : "") + routeDetails?.state;
        }

        if (routeDetails?.country) {
            address = address + (address ? "," : "") + routeDetails?.country;
        }

        return address;
    }

    // #endregion  ***methods to modify data ***

    //#region ***Distance Calculation***

    async calculateDistance(mapId: string = 'gmap1') {

        const myLatLng = { lat: 0, lng: 0 };
        let map = new google.maps.Map(document.getElementById(mapId), {
            zoom: 5,
            center: myLatLng,
        });

        const routeAddressLatLngList: any[] = [];
        for (var i in this.editRouteStoreList) {
            var obj = this.editRouteStoreList[i];
            const routeLocation = this.formatAddress(obj);

            if (routeLocation != "") {
                const eachRoute = {
                    id: obj.routeObjectId,
                    businessName: obj.businessName,
                    city: obj.city,
                    isSelected: obj.isSelected,
                    latitude: this.convertToNum(obj.latitude),
                    longitude: this.convertToNum(obj.longitude),
                    channelId: obj?.channelId,
                    territoryId: obj?.territoryId,
                    objectRefId: obj.objectRefId,
                    objectRefRecordId: obj.objectRefRecordId,
                    totalDistance: 0,
                    totalTime: '',
                    objectType: obj.objectType,
                    routeAssigned: obj.routeAssigned,
                    routeObjectId: obj.routeObjectId,
                    state: obj.state,
                    street: obj.street,
                    address: routeLocation
                }

                let element = await this.routeManagementService.getlatlng(eachRoute, (eachRoute?.address));

                let elat = element.res.results?.length > 0 ? this.convertToNum(element.res.results[0].geometry.location.lat) : 0;
                let elng = element.res.results?.length > 0 ? this.convertToNum(element.res.results[0].geometry.location.lng) : 0;

                const storePoint = { lat: elat, lng: elng };
                await this.collectRouteMarkerLatlngList1(element.obj, storePoint, map, routeAddressLatLngList);
            }
        }
    }

    async collectRouteMarkerLatlngList1(obj, point, map, routeAddressLatLngList) {
        routeAddressLatLngList.push({
            'obj': obj,
            'point': point
        });

        if (routeAddressLatLngList?.length == this.editRouteStoreList?.length) {
            localStorage.setItem("markerlist", JSON.stringify(routeAddressLatLngList));
            await this.getMarkerInsideDrawing1('', map, true);
        }
    }

    async getMarkerInsideDrawing1(poly: any, map: any, initonload: boolean) {

        let startLatLang: any = {
            lat: this.startAddress?.latitude || 0,
            lng: this.startAddress?.longitude || 0
        }

        let endLatLang: any = {
            lat: this.endAddress?.latitude || 0,
            lng: this.endAddress?.longitude || 0
        }

        if (this.routeForm.value.isEndLocationSame) {
            endLatLang = startLatLang;
        }

        let filterMarker = [];
        let markerInsideDrawingList = JSON.parse(localStorage.getItem("markerlist"));
        if (!(!!markerInsideDrawingList && !!markerInsideDrawingList[0])) {
            ////console.log("Empty routes marker array list ");
            return;
        }

        let filterMarkerLatLng = [];
        for (let i = 0; i < markerInsideDrawingList?.length; i++) {
            let point = new google.maps.LatLng(this.convertToNum(markerInsideDrawingList[i].point.lat), this.convertToNum(markerInsideDrawingList[i].point.lng));
            if (!initonload && google.maps.geometry.poly.containsLocation(point, poly) == true) {
                filterMarker.push(markerInsideDrawingList[i]);
                filterMarkerLatLng.push(point);
            } else if (initonload && markerInsideDrawingList[i].obj.isSelected) {
                filterMarker.push(markerInsideDrawingList[i]);
                filterMarkerLatLng.push(point);
            }
        }

        try {

            let startLatLng, destinationLatLng, waypoints;
            let directionsService = new google.maps.DirectionsService();
            let directionsRenderer = new google.maps.DirectionsRenderer(
                { suppressMarkers: true }
            );
            directionsRenderer.setMap(map);

            if (!!startLatLang['lat'] && !!startLatLang['lng']) {
                startLatLng = new google.maps.LatLng(this.convertToNum(startLatLang['lat']), this.convertToNum(startLatLang['lng']));
            } else if (typeof startLatLang === "string" && startLatLang?.length != 0) {
                startLatLng = startLatLang;
            }

            if (!!endLatLang['lat'] && !!endLatLang['lng']) {
                destinationLatLng = new google.maps.LatLng(this.convertToNum(endLatLang['lat']), this.convertToNum(endLatLang['lng']));
            } else if (typeof endLatLang === "string" && endLatLang?.length != 0) {
                destinationLatLng = endLatLang;
            }

            waypoints = [];
            if (destinationLatLng != null && destinationLatLng != '' && destinationLatLng != undefined) {
                for (let j = 0; j < filterMarkerLatLng?.length; j++) {
                    let waypt = {
                        location: filterMarkerLatLng[j],
                        stopover: true,
                    }
                    waypoints.push(waypt);
                }
            }
            else {
                for (let j = 0; j < filterMarkerLatLng?.length; j++) {
                    if (j == filterMarkerLatLng?.length - 1) {
                        destinationLatLng = filterMarkerLatLng[j];
                    } else {
                        let waypt = {
                            location: filterMarkerLatLng[j],
                            stopover: true,
                        }
                        waypoints.push(waypt);
                    }
                }
            }

            let request: any = {
                origin: startLatLng,
                destination: destinationLatLng,
                waypoints: waypoints,
                travelMode: 'DRIVING',
                optimizeWaypoints: true,
                provideRouteAlternatives: false,
                drivingOptions: {
                    departureTime: new Date(Date.now()),
                    trafficModel: 'optimistic'
                },
            };


            let totalMinutes = '';
            let totalDistance = '';
            directionsRenderer.addListener("directions_changed", () => {
                const result = directionsRenderer.getDirections();
                let totalmins = 0;
                let total = 0;
                const myroute = result.routes[0];
                if (!myroute) {
                    return;
                }

                for (let i = 0; i < myroute.legs?.length; i++) {
                    total += myroute.legs[i]!.distance!.value;
                    totalmins += myroute.legs[i]!.duration!.value;
                    if (this.editRouteStoreList != null && this.editRouteStoreList?.length > 0 && i < myroute.legs?.length - 1) {
                        this.editRouteStoreList[i].totalDistance = myroute.legs[i]!.distance!.value / 1609;
                        this.editRouteStoreList[i].totalTime = Math.ceil(myroute.legs[i]!.duration!.value / 60) + ' mins';
                    }
                }
                total = total / 1609;
                if (totalmins / 3600 > 1) {
                    let time = parseFloat("" + totalmins / 3600 + "").toFixed(2);
                    let timediff = time.split(".");
                    let hour = timediff[0];
                    let minute = timediff[1];
                    const hourstr = parseInt(hour) > 1 ? hour + ' hours ' : hour + ' hour '
                    totalMinutes = hourstr + minute + ' mins';
                }
                else {
                    totalMinutes = Math.ceil(totalmins / 60) + ' mins';
                }
                totalDistance = parseFloat("" + total + "").toFixed(2);
                localStorage.setItem("totalDistance", totalDistance + "");
                localStorage.setItem("totalMinutes", totalMinutes + "");
            });


            //let directionsRenderer = this.directionsRenderer;

            await directionsService.route(request, function (response, status) {
                if (status == 'OK') {
                    directionsRenderer.setDirections(response);

                    let pathList = [];

                    var route = response.routes[0];
                    var infowindowStart = new google.maps.InfoWindow();
                    var strstartcontent = "";
                    strstartcontent += "<b>Start From Here...</b><br> " + route.legs[0].start_address + "<br>";
                    var markerStart = new google.maps.Marker({
                        position: route.legs[0].start_location,
                        map: map,
                        label: {
                            color: '#fff',
                            text: 'S'
                        },
                        title: 'Start From Here...'
                    });

                    pathList.push({
                        address: route.legs[0].start_address,
                        duration: route.legs[0].duration,
                        distance: { text: parseFloat("" + route.legs[0].distance?.value / 1609 + "").toFixed(2) + ' miles', value: route.legs[0].distance?.value },
                        businessName: 'Start Location'
                    });


                    google.maps.event.addListener(markerStart, 'click', (function (markerStart, strstartcontent, infowindowStart) {
                        return function () {
                            infowindowStart.setContent(strstartcontent);
                            infowindowStart.open(map, markerStart);
                        };
                    })(markerStart, strstartcontent, infowindowStart));

                    var waypointOrders = [];

                    if (route.waypoint_order != null) {
                        waypointOrders = route.waypoint_order;
                    }

                    //var totalDistance=0;
                    for (var i = 0; i < route.legs?.length; i++) {
                        var infowindow2 = new google.maps.InfoWindow();
                        var storeName = '';
                        var wpInx = waypointOrders[i];
                        if (wpInx != undefined && wpInx != null) {
                            storeName = markerInsideDrawingList[wpInx].obj.businessName;
                        }

                        var strcontent = "";
                        strcontent += "<b>" + (i + 1) + ") " + storeName + " </b><br> " + route.legs[i].end_address + "<br>";

                        if (i == route.legs?.length - 1) {
                            var marker = new google.maps.Marker({
                                position: route.legs[i].end_location,
                                map: map,
                                label: {
                                    color: '#fff',
                                    text: 'E'
                                },
                                title: storeName
                            });

                            pathList.push({
                                address: route.legs[i].end_address,
                                duration: route.legs[i].duration,
                                distance: { text: parseFloat("" + route.legs[i].distance?.value / 1609 + "").toFixed(2) + ' miles', value: route.legs[i].distance?.value },
                                businessName: 'End Location'
                            });
                        }
                        else {
                            var marker = new google.maps.Marker({
                                position: route.legs[i].end_location,
                                map: map,
                                label: {
                                    color: '#fff',
                                    text: '' + (i + 1)
                                },
                                title: storeName
                            });

                            pathList.push({
                                address: route.legs[i].end_address,
                                duration: route.legs[i].duration,
                                distance: { text: parseFloat("" + route.legs[i].distance?.value / 1609 + "").toFixed(2) + ' miles', value: route.legs[i].distance?.value },
                                businessName: storeName
                            });
                        }

                        google.maps.event.addListener(marker, 'click', (function (marker, strcontent, infowindow2) {
                            return function () {
                                infowindow2.setContent(strcontent);
                                infowindow2.open(map, marker);
                            };
                        })(marker, strcontent, infowindow2));
                    }
                }
            });

        } catch (error) { }
    }

    //#endregion ***End Distance Calculation***

    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }
}
